import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';

import { colors, breakpoints, fontFamily, zIndex } from '../../ui/variables';

export const ControlPanelStyle = styled.main`
  background-color: ${colors.gray};
  box-sizing: border-box;
  min-height: 100vh;
  padding: ${headerVariables.main.height.iphone}px 0 20px;
  width: 100%;
  padding-left: 4%;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    padding-right: 20%;
  }

  .snack-bar-wrapper {
    ${zIndex.hills};
    left: 0;
    position: fixed;
    top: ${headerVariables.main.height.iphone}px;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      top: ${headerVariables.main.height.iphone}px;
    }
  }

  .header-users-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 73px;
    margin-bottom: 35px;
    padding-left: 20px;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .title-header {
      ${fontFamily.sourceSansPro.bold}
      font-size: 24px;
      margin-bottom: 10px;

      .number-of-registers {
        display: none;
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          display: inline-block;
          ${fontFamily.sourceSansPro.regular}
          font-size: 14px;
        }

        .score {
          ${fontFamily.sourceSansPro.bold}
          font-size: 14px;
          margin-left: 20px;
        }
      }
    }
    .button-wrapper {
      margin-right: 10px;
      width: 219px;
      height: 45px;
    }
  }

  .users-list-form {
    padding: 0 20px;
  }

  .select-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 15px 0;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .select-container {
      width: 100%;
      margin: 5px 0;
      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        width: 40%;
      }
    }
  }

  .users-list {
    width: 100%;
    margin-top: 38px;

    .users-list-table-head {
      display: none;
      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
      }

      .table-head-item {
        justify-content: left;

        &.name-item {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 20%;
            min-width: 20%;
            padding-left: 12px;
          }
        }

        &.matriculation-item {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 111px;
            min-width: 111px;
          }
        }

        &.role-item {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 90px;
            min-width: 90px;
          }
        }

        &.registration-date-item {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 100px;
            min-width: 100px;
          }
        }

        &.patient-data-item {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 111px;
            min-width: 111px;
          }
        }

        &.images-exams-item {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 111px;
            min-width: 111px;
          }
        }

        &.report-results-item {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 111px;
            min-width: 111px;
          }
        }

        &.actions-item {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 190px;
            min-width: 190px;
            padding-left: 12px;
          }
        }
      }
    }

    .users-list-data {
      width: 100%;
      .user-list-item {
        position: relative;
        width: 100%;
        height: 110px;
        padding-left: 60px;
        background-color: ${colors.mostlyWhite};
        border-radius: 19px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          display: table;
          height: 81px;
          padding-left: 0;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
        }

        .user-list-item-data {
          justify-content: left;
          display: table-cell;
          vertical-align: middle;
          margin-bottom: 3px;

          &.name-list-item {
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              max-width: 21%;
              min-width: 21%;
              padding-left: 12px;
              margin-right: 2%;
            }
          }

          &.matriculation-list-item {
            display: none;
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              display: table-cell;
              max-width: 11%;
              min-width: 11%;
            }
          }

          &.role-list-item {
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              max-width: 10%;
              min-width: 10%;
            }
          }

          &.registration-date-list-item {
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              max-width: 13%;
              min-width: 13%;
            }
          }

          &.patient-data-list-item {
            display: none;
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              display: table-cell;
              max-width: 10%;
              min-width: 10%;
            }
          }

          &.images-exams-list-item {
            display: none;
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              display: table-cell;
              max-width: 10%;
              min-width: 10%;
            }
          }

          &.report-results-list-item {
            display: none;
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              display: table-cell;
              max-width: 10%;
              min-width: 10%;
            }
          }

          &.actions-list-item {
            position: absolute;
            bottom: 24px;
            right: 34px;
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              top: 0;
              right: 0;
              position: relative;
              width: 80px;
              height: 100%;
            }
            .actions-item {
              width: 80px;
              display: flex;
              justify-content: space-around;
              @media (min-width: ${breakpoints.ipadLandscape.width}px) {
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: space-around;
              }
            }
          }
        }

        .go-to-user-text {
          position: absolute;
          top: 14px;
          right: 34px;
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            display: none;
          }
        }
      }
    }
  }
`;
